import { render, staticRenderFns } from "./slujebni-update.vue?vue&type=template&id=bf30a806"
import script from "./slujebni-update.vue?vue&type=script&lang=js"
export * from "./slujebni-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports